unit unit_EinzelEmail;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.Grids, Data.DB, WEBLib.DB,
  XData.Web.JsonDataset, XData.Web.Dataset, Vcl.StdCtrls, WEBLib.StdCtrls, strutils,
  DB, WEBLib.ExtCtrls;

type
  TEinzelEmail = class(TForm)
    TC: TTableControl;
    xdsEmails: TXDataWebDataSet;
    xdsEmailsEmailEmpfangenUhrzeit: TDateTimeField;
    xdsEmailsID: TIntegerField;
    xdsEmailsarchiviert: TStringField;
    xdsEmailsEmailFrom: TStringField;
    xdsEmailsEmailFromName: TStringField;
    xdsEmailsEmailTo: TStringField;
    xdsEmailsEmailCC: TStringField;
    xdsEmailsEmailBetreff: TStringField;
    xdsEmailsEmailPriority: TIntegerField;
    xdsEmailsEmailOrganization: TStringField;
    xdsEmailsEmailbearbeitet: TDateTimeField;
    xdsEmailsEmailbearbeitetvon: TStringField;
    xdsEmailsKundennummer: TStringField;
    xdsEmailsPosteingang: TBooleanField;
    xdsEmailsEmailID: TStringField;
    xdsEmailsEmailReceipt: TStringField;
    xdsEmailsEmailgelesen: TDateTimeField;
    xdsEmailsEmailContentType: TStringField;
    xdsEmailsEmailgelesenvon: TStringField;
    xdsEmailsEmailReplyTo: TStringField;
    xdsEmailsEmailReplyToName: TStringField;
    xdsEmailsEmailUIDL: TStringField;
    xdsEmailsEmailBCC: TStringField;
    xdsEmailsEmailBest: TBooleanField;
    xdsEmailsSchreibzeichen: TStringField;
    xdsEmailsGesendete: TBooleanField;
    xdsEmailsGesendetUhrzeit: TDateTimeField;
    xdsEmailsPersNo: TIntegerField;
    xdsEmailsPersColor: TIntegerField;
    xdsEmailsBearbeitungsnotiz: TStringField;
    xdsEmailsNurText: TStringField;
    xdsEmailsObjektReferenz: TStringField;
    xdsEmailsObjektnummer: TStringField;
    xdsEmailsEmailKonto: TStringField;
    xdsEmailsFreigabe: TStringField;
    sourceEmails: TDataSource;
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    Container3: THTMLContainer;
    MSGLOESCHEN: TMessageDlg;
    xdsEmailsEmailBody: TStringField;
    xdsEmailsMSG: TStringField;
    lblEmailArt: TLabel;
    btnzurueck: TButton;
    btnKontaktZuordnen: TButton;
    btnTicketErstellen: TButton;
    btnEmailLoeschen: TButton;
    xdsEGesendet: TXDataWebDataSet;
    xdsEGesendetEmailBetreff: TStringField;
    xdsEGesendetKundennummer: TStringField;
    xdsEGesendetgesendetUhrzeit: TDateTimeField;
    xdsEGesendetBearbeitungsnotiz: TStringField;
    xdsEGesendetEmailFrom: TStringField;
    xdsEGesendetEmailFromName: TStringField;
    xdsEGesendetEmailTo: TStringField;
    xdsEGesendetEmailCC: TStringField;
    xdsEGesendetEmailBCC: TStringField;
    xdsEGesendetEmailBody: TStringField;
    xdsEGesendetID: TIntegerField;
    procedure WebFormShow(Sender: TObject);
    procedure xdsEmailsAfterOpen(DataSet: TDataSet);
    procedure btnzurueckClick(Sender: TObject);
    [async] procedure btnKontaktZuordnenClick(Sender: TObject); async;
    procedure xdsEmailsAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure btnTicketErstellenClick(Sender: TObject);
    [async] procedure btnEmailLoeschenClick(Sender: TObject); async;
    procedure xdsEmailsAfterDelete(DataSet: TDataSet);
    procedure xdsEmailsAfterPost(DataSet: TDataSet);
    procedure xdsEGesendetAfterOpen(DataSet: TDataSet);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }

    EmailID:string;
    Posteingang:integer;
    IsLoeschung:boolean;
  protected procedure LoadDFMValues; override; end;

var
  EinzelEmail: TEinzelEmail;

implementation
  uses unit1, unit2, unit_Kontaktsuche, unit_TicketNeu;
{$R *.dfm}

procedure TEinzelEmail.btnEmailLoeschenClick(Sender: TObject);
var
  mr: TModalResult;
begin
  mr := await(TModalResult, Msgloeschen.ShowDialog('Das Löschen einer Email kann nicht rückgängig gemacht werden. Wollen Sie die Email wirklich löschen?', WEBLib.Dialogs.mtConfirmation,[mbYes, mbNo]));
  if mr = mrYes then xdsEmails.Delete;
end;

procedure TEinzelEmail.btnKontaktZuordnenClick(Sender: TObject);
var
  LFrm:TfrmKontaktsuche;
  mr: TModalResult;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TfrmKontaktsuche;
    begin
      LForm:=(AForm as TfrmKontaktsuche);
      lform.Kontaktnummer:='';
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      if lfrm.Kontaktnummer<>'' then
      begin
        xdsEmails.edit;
        xdsEmailsKundennummer.AsString:=lfrm.Kontaktnummer;
        xdsEmails.Post;
      end;
    end;

  begin

  if xdsEmailsKundennummer.AsString<>'' then
  begin
    mr := await(TModalResult, Msgloeschen.ShowDialog('Diese Email ist bereits einer Kundenakte zugeordnet, wollen Sie wirklich eine Änderung vornehmen?', WEBLib.Dialogs.mtConfirmation,[mbYes, mbNo]));
    if mr = mrYes then
    begin
      LFrm:=TfrmKontaktsuche.CreateNew(@AfterCreate);
      LFrm.ShowModal(@AfterShowmodal);
    end;
  end
  else
  begin
    LFrm:=TfrmKontaktsuche.CreateNew(@AfterCreate);
    LFrm.ShowModal(@AfterShowmodal);
  end;
end;

procedure TEinzelEmail.btnTicketErstellenClick(Sender: TObject);
var
  LFrm:TTicketNeu;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TTicketNeu;
    begin
      TC.Visible:=false;
      LForm:=(AForm as TTicketNeu);
      lform.TicketNeuFuerKundennummer:=xdsEmailsKundennummer.AsString;
      lform.TicketNeuBetreff:=xdsEmailsEmailBetreff.AsString;
      lform.TicketNeuText:=xdsEmailsNurText.AsString;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      if lfrm.NewTicketNumber<>'' then
      begin
        xdsEmails.edit;
        xdsEmailsBearbeitungsnotiz.AsString:='Ticket erstellt Nr. '+lfrm.NewTicketNumber;
        xdsEmails.Post;
      end;
    end;
  begin
      LFrm:=TTicketNeu.CreateNew(@AfterCreate);
      LFrm.ShowModal(@AfterShowmodal);
end;

procedure TEinzelEmail.btnzurueckClick(Sender: TObject);
begin
  xdsEmails.Close;
  self.Close;
end;

procedure TEinzelEmail.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Emailanzeige</h5></nav>';
  myelement:=Container1.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  btnZurueck.ParentElement:=myelement;
  btnKontaktZuordnen.ParentElement:=myelement;
  btnTicketErstellen.ParentElement:=myelement;
  btnEmailloeschen.ParentElement:=myelement;
  Container2.ParentElement:=myelement;
  Container3.ParentElement:=myelement;
  myelement:=container2.ElementHandle;
  lblEmailArt.ParentElement:=myelement;
  If Posteingang=0 then
  begin
    lblEmailArt.caption:='Erhaltene Email';
    xdsEmails.Close;
    xdsEmails.QueryString:='$filter=ID eq '+EmailID;
    xdsEmails.Load;
  end;
  If Posteingang=1 then
  begin
   lblEmailArt.caption:='Gesendete Email';
    xdsEGesendet.Close;
    xdsEGesendet.QueryString:='$filter=ID eq '+EmailID;
    xdsEGesendet.Load;
  end;

end;

procedure TEinzelEmail.xdsEGesendetAfterOpen(DataSet: TDataSet);
var
  i:integer;
  myelement:TJSHTMLElement;
begin
  Container3.HTML.Text:='';
  myelement:=container3.ElementHandle;
  if Posteingang=1 then
  begin
    btnKontaktZuordnen.Enabled:=false;
    btnTicketErstellen.enabled:=false;
    btnEmailLoeschen.enabled:=false;
  end;
  tc.ParentElement:=myelement;

  isloeschung:=false;
  TC.Colcount:=2;
  tc.cells[0,i]:='ID';
  TC.Cells[1,i]:=xdsEGesendetID.asstring;
  tc.rowcount:=11;

  inc(i);
  tc.cells[0,i]:='von';
  tc.cells[1,i]:=xdsEGesendetEmailFromName.asstring+' ('+xdsEGesendetEmailFrom.asstring+')';

  inc(i);
  tc.cells[0,i]:='an';
  tc.cells[1,i]:=xdsEGesendetEmailTo.asstring;

  inc(i);
  tc.cells[0,i]:='CC';
  tc.cells[1,i]:=xdsEGesendetEmailCC.asstring;

  inc(i);
  tc.cells[0,i]:='BCC';
  tc.cells[1,i]:=xdsEGesendetEmailBCC.asstring;

  inc(i);
  tc.cells[1,i]:=xdsEGesendetgesendetUhrzeit.asstring;
  tc.cells[0,i]:='um';

  inc(i);
  tc.cells[1,i]:='<b>'+xdsEGesendetEmailBetreff.asstring+'</b>';

  inc(i);
  tc.cells[1,i]:=replacestr(xdsEGesendetEmailBody.asstring,#13+#10,'<BR>');

  inc(i);
  tc.cells[1,i]:=xdsEGesendetKundennummer.asstring;
  tc.cells[0,i]:='KDNR';

  inc(i);
  tc.cells[1,i]:=xdsEGesendetBearbeitungsnotiz.asstring;
  tc.cells[0,i]:='Notiz';
end;

procedure TEinzelEmail.xdsEmailsAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;
  if info.Records[0].Error='' then
  begin
    xdsEmails.Close;
    if IsLoeschung then
    begin
      self.Close;
    end
    else
    begin
      xdsEmails.Load;
    end;
  end;
end;

procedure TEinzelEmail.xdsEmailsAfterDelete(DataSet: TDataSet);
begin
  IsLoeschung:=true;
  xdsEmails.ApplyUpdates;
  close;
end;

procedure TEinzelEmail.xdsEmailsAfterOpen(DataSet: TDataSet);
var
  i:integer;
  myelement:TJSHTMLElement;
begin
  Container3.HTML.Text:='';
  myelement:=container3.ElementHandle;
  if Posteingang=0 then
  begin
    btnKontaktZuordnen.Enabled:=true;
    btnTicketErstellen.enabled:=true;
    btnEmailLoeschen.enabled:=true;
  end;
  tc.ParentElement:=myelement;

  isloeschung:=false;
  TC.Colcount:=2;
  tc.cells[0,i]:='ID';
  TC.Cells[1,i]:=xdsemailsid.asstring;
  tc.rowcount:=9;

  inc(i);
  tc.cells[0,i]:='von';
  tc.cells[1,i]:=xdsemailsEmailFromName.asstring+' ('+xdsemailsEmailFrom.asstring+')';

  inc(i);
  tc.cells[0,i]:='an';
  tc.cells[1,i]:=xdsemailsEmailKonto.asstring;

  inc(i);
  tc.cells[0,i]:='cc';
  tc.cells[1,i]:=xdsemailsEmailCC.asstring;

  inc(i);
  tc.cells[1,i]:=xdsemailsEmailEmpfangenUhrzeit.asstring;
  tc.cells[0,i]:='um';

  inc(i);
  tc.cells[1,i]:='<b>'+xdsemailsemailbetreff.asstring+'</b><br>'+ replacestr(xdsemailsNurText.asstring,#13+#10,'<BR>');

  inc(i);
  tc.cells[1,i]:=xdsEmailsKundennummer.asstring;
  tc.cells[0,i]:='KDNR';

  inc(i);
  tc.cells[1,i]:=xdsEmailsBearbeitungsnotiz.asstring;
  tc.cells[0,i]:='Notiz';

  if xdsEmailsarchiviert.AsString<>'' then btnKontaktZuordnen.Enabled:=false else btnKontaktZuordnen.Enabled:=true;
  if xdsEmailsarchiviert.AsString<>'' then btnEmailLoeschen.Enabled:=false else btnEmailLoeschen.Enabled:=true;
end;

procedure TEinzelEmail.xdsEmailsAfterPost(DataSet: TDataSet);
begin
  xdsEmails.ApplyUpdates;
end;

procedure TEinzelEmail.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lblEmailArt := TLabel.Create(Self);
  TC := TTableControl.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  MSGLOESCHEN := TMessageDlg.Create(Self);
  btnzurueck := TButton.Create(Self);
  btnKontaktZuordnen := TButton.Create(Self);
  btnTicketErstellen := TButton.Create(Self);
  btnEmailLoeschen := TButton.Create(Self);
  xdsEmails := TXDataWebDataSet.Create(Self);
  xdsEmailsEmailEmpfangenUhrzeit := TDateTimeField.Create(Self);
  xdsEmailsID := TIntegerField.Create(Self);
  xdsEmailsarchiviert := TStringField.Create(Self);
  xdsEmailsEmailFrom := TStringField.Create(Self);
  xdsEmailsEmailFromName := TStringField.Create(Self);
  xdsEmailsEmailTo := TStringField.Create(Self);
  xdsEmailsEmailCC := TStringField.Create(Self);
  xdsEmailsEmailBetreff := TStringField.Create(Self);
  xdsEmailsEmailPriority := TIntegerField.Create(Self);
  xdsEmailsEmailOrganization := TStringField.Create(Self);
  xdsEmailsEmailbearbeitet := TDateTimeField.Create(Self);
  xdsEmailsEmailbearbeitetvon := TStringField.Create(Self);
  xdsEmailsKundennummer := TStringField.Create(Self);
  xdsEmailsPosteingang := TBooleanField.Create(Self);
  xdsEmailsEmailID := TStringField.Create(Self);
  xdsEmailsEmailReceipt := TStringField.Create(Self);
  xdsEmailsEmailgelesen := TDateTimeField.Create(Self);
  xdsEmailsEmailContentType := TStringField.Create(Self);
  xdsEmailsEmailgelesenvon := TStringField.Create(Self);
  xdsEmailsEmailReplyTo := TStringField.Create(Self);
  xdsEmailsEmailReplyToName := TStringField.Create(Self);
  xdsEmailsEmailUIDL := TStringField.Create(Self);
  xdsEmailsEmailBCC := TStringField.Create(Self);
  xdsEmailsEmailBest := TBooleanField.Create(Self);
  xdsEmailsSchreibzeichen := TStringField.Create(Self);
  xdsEmailsGesendete := TBooleanField.Create(Self);
  xdsEmailsGesendetUhrzeit := TDateTimeField.Create(Self);
  xdsEmailsPersNo := TIntegerField.Create(Self);
  xdsEmailsPersColor := TIntegerField.Create(Self);
  xdsEmailsBearbeitungsnotiz := TStringField.Create(Self);
  xdsEmailsNurText := TStringField.Create(Self);
  xdsEmailsObjektReferenz := TStringField.Create(Self);
  xdsEmailsObjektnummer := TStringField.Create(Self);
  xdsEmailsEmailKonto := TStringField.Create(Self);
  xdsEmailsFreigabe := TStringField.Create(Self);
  xdsEmailsEmailBody := TStringField.Create(Self);
  xdsEmailsMSG := TStringField.Create(Self);
  sourceEmails := TDataSource.Create(Self);
  xdsEGesendet := TXDataWebDataSet.Create(Self);
  xdsEGesendetEmailBetreff := TStringField.Create(Self);
  xdsEGesendetKundennummer := TStringField.Create(Self);
  xdsEGesendetgesendetUhrzeit := TDateTimeField.Create(Self);
  xdsEGesendetBearbeitungsnotiz := TStringField.Create(Self);
  xdsEGesendetEmailFrom := TStringField.Create(Self);
  xdsEGesendetEmailFromName := TStringField.Create(Self);
  xdsEGesendetEmailTo := TStringField.Create(Self);
  xdsEGesendetEmailCC := TStringField.Create(Self);
  xdsEGesendetEmailBCC := TStringField.Create(Self);
  xdsEGesendetEmailBody := TStringField.Create(Self);
  xdsEGesendetID := TIntegerField.Create(Self);

  lblEmailArt.BeforeLoadDFMValues;
  TC.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  MSGLOESCHEN.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  btnKontaktZuordnen.BeforeLoadDFMValues;
  btnTicketErstellen.BeforeLoadDFMValues;
  btnEmailLoeschen.BeforeLoadDFMValues;
  xdsEmails.BeforeLoadDFMValues;
  xdsEmailsEmailEmpfangenUhrzeit.BeforeLoadDFMValues;
  xdsEmailsID.BeforeLoadDFMValues;
  xdsEmailsarchiviert.BeforeLoadDFMValues;
  xdsEmailsEmailFrom.BeforeLoadDFMValues;
  xdsEmailsEmailFromName.BeforeLoadDFMValues;
  xdsEmailsEmailTo.BeforeLoadDFMValues;
  xdsEmailsEmailCC.BeforeLoadDFMValues;
  xdsEmailsEmailBetreff.BeforeLoadDFMValues;
  xdsEmailsEmailPriority.BeforeLoadDFMValues;
  xdsEmailsEmailOrganization.BeforeLoadDFMValues;
  xdsEmailsEmailbearbeitet.BeforeLoadDFMValues;
  xdsEmailsEmailbearbeitetvon.BeforeLoadDFMValues;
  xdsEmailsKundennummer.BeforeLoadDFMValues;
  xdsEmailsPosteingang.BeforeLoadDFMValues;
  xdsEmailsEmailID.BeforeLoadDFMValues;
  xdsEmailsEmailReceipt.BeforeLoadDFMValues;
  xdsEmailsEmailgelesen.BeforeLoadDFMValues;
  xdsEmailsEmailContentType.BeforeLoadDFMValues;
  xdsEmailsEmailgelesenvon.BeforeLoadDFMValues;
  xdsEmailsEmailReplyTo.BeforeLoadDFMValues;
  xdsEmailsEmailReplyToName.BeforeLoadDFMValues;
  xdsEmailsEmailUIDL.BeforeLoadDFMValues;
  xdsEmailsEmailBCC.BeforeLoadDFMValues;
  xdsEmailsEmailBest.BeforeLoadDFMValues;
  xdsEmailsSchreibzeichen.BeforeLoadDFMValues;
  xdsEmailsGesendete.BeforeLoadDFMValues;
  xdsEmailsGesendetUhrzeit.BeforeLoadDFMValues;
  xdsEmailsPersNo.BeforeLoadDFMValues;
  xdsEmailsPersColor.BeforeLoadDFMValues;
  xdsEmailsBearbeitungsnotiz.BeforeLoadDFMValues;
  xdsEmailsNurText.BeforeLoadDFMValues;
  xdsEmailsObjektReferenz.BeforeLoadDFMValues;
  xdsEmailsObjektnummer.BeforeLoadDFMValues;
  xdsEmailsEmailKonto.BeforeLoadDFMValues;
  xdsEmailsFreigabe.BeforeLoadDFMValues;
  xdsEmailsEmailBody.BeforeLoadDFMValues;
  xdsEmailsMSG.BeforeLoadDFMValues;
  sourceEmails.BeforeLoadDFMValues;
  xdsEGesendet.BeforeLoadDFMValues;
  xdsEGesendetEmailBetreff.BeforeLoadDFMValues;
  xdsEGesendetKundennummer.BeforeLoadDFMValues;
  xdsEGesendetgesendetUhrzeit.BeforeLoadDFMValues;
  xdsEGesendetBearbeitungsnotiz.BeforeLoadDFMValues;
  xdsEGesendetEmailFrom.BeforeLoadDFMValues;
  xdsEGesendetEmailFromName.BeforeLoadDFMValues;
  xdsEGesendetEmailTo.BeforeLoadDFMValues;
  xdsEGesendetEmailCC.BeforeLoadDFMValues;
  xdsEGesendetEmailBCC.BeforeLoadDFMValues;
  xdsEGesendetEmailBody.BeforeLoadDFMValues;
  xdsEGesendetID.BeforeLoadDFMValues;
  try
    Name := 'EinzelEmail';
    Width := 682;
    Height := 585;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lblEmailArt.SetParentComponent(Self);
    lblEmailArt.Name := 'lblEmailArt';
    lblEmailArt.Left := 8;
    lblEmailArt.Top := 179;
    lblEmailArt.Width := 58;
    lblEmailArt.Height := 15;
    lblEmailArt.Caption := 'lblEmailArt';
    lblEmailArt.ElementClassName := 'h3 m-2';
    lblEmailArt.ElementFont := efCSS;
    lblEmailArt.HeightStyle := ssAuto;
    lblEmailArt.HeightPercent := 100.000000000000000000;
    lblEmailArt.WidthPercent := 100.000000000000000000;
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 22;
    TC.Top := 312;
    TC.Width := 193;
    TC.Height := 137;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.WidthStyle := ssAuto;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 3;
    TC.ColHeader := False;
    TC.ElementFont := efCSS;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementPosition := epIgnore;
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 1;
    TC.RowCount := 5;
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.ElementClassName := 'container-fluid rounded';
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ChildOrder := 2;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 5;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex flex-wrap m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 5;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    MSGLOESCHEN.SetParentComponent(Self);
    MSGLOESCHEN.Name := 'MSGLOESCHEN';
    MSGLOESCHEN.Left := 304;
    MSGLOESCHEN.Top := 440;
    MSGLOESCHEN.Width := 24;
    MSGLOESCHEN.Height := 24;
    MSGLOESCHEN.HeightStyle := ssAuto;
    MSGLOESCHEN.WidthStyle := ssAuto;
    MSGLOESCHEN.Buttons := [mbYes,mbNo];
    MSGLOESCHEN.DialogType := mtConfirmation;
    MSGLOESCHEN.Message := 'Das L'#246'schen einer Datei kann nicht r'#252'ckg'#228'ngig gemacht werden.Wollen Sie die Datei wirklich l'#246'schen?';
    MSGLOESCHEN.Opacity := 0.200000000000000000;
    MSGLOESCHEN.ElementButtonClassName := 'btn';
    MSGLOESCHEN.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    MSGLOESCHEN.ElementTitleClassName := 'text-body';
    MSGLOESCHEN.ElementContentClassName := 'text-body';
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 8;
    btnzurueck.Top := 141;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-sm bg-info m-1';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    btnKontaktZuordnen.SetParentComponent(Self);
    btnKontaktZuordnen.Name := 'btnKontaktZuordnen';
    btnKontaktZuordnen.Left := 110;
    btnKontaktZuordnen.Top := 141;
    btnKontaktZuordnen.Width := 96;
    btnKontaktZuordnen.Height := 25;
    btnKontaktZuordnen.Caption := 'zu Kontakt';
    btnKontaktZuordnen.ChildOrder := 12;
    btnKontaktZuordnen.ElementClassName := 'btn btn-sm bg-info m-1';
    btnKontaktZuordnen.ElementFont := efCSS;
    btnKontaktZuordnen.ElementPosition := epIgnore;
    btnKontaktZuordnen.HeightStyle := ssAuto;
    btnKontaktZuordnen.HeightPercent := 100.000000000000000000;
    btnKontaktZuordnen.WidthStyle := ssAuto;
    btnKontaktZuordnen.WidthPercent := 100.000000000000000000;
    SetEvent(btnKontaktZuordnen, Self, 'OnClick', 'btnKontaktZuordnenClick');
    btnTicketErstellen.SetParentComponent(Self);
    btnTicketErstellen.Name := 'btnTicketErstellen';
    btnTicketErstellen.Left := 212;
    btnTicketErstellen.Top := 141;
    btnTicketErstellen.Width := 96;
    btnTicketErstellen.Height := 25;
    btnTicketErstellen.Caption := 'Ticket';
    btnTicketErstellen.ChildOrder := 12;
    btnTicketErstellen.ElementClassName := 'btn btn-sm bg-info m-1';
    btnTicketErstellen.ElementFont := efCSS;
    btnTicketErstellen.ElementPosition := epIgnore;
    btnTicketErstellen.HeightStyle := ssAuto;
    btnTicketErstellen.HeightPercent := 100.000000000000000000;
    btnTicketErstellen.WidthStyle := ssAuto;
    btnTicketErstellen.WidthPercent := 100.000000000000000000;
    SetEvent(btnTicketErstellen, Self, 'OnClick', 'btnTicketErstellenClick');
    btnEmailLoeschen.SetParentComponent(Self);
    btnEmailLoeschen.Name := 'btnEmailLoeschen';
    btnEmailLoeschen.Left := 314;
    btnEmailLoeschen.Top := 141;
    btnEmailLoeschen.Width := 96;
    btnEmailLoeschen.Height := 25;
    btnEmailLoeschen.Caption := 'L'#246'schen';
    btnEmailLoeschen.ChildOrder := 12;
    btnEmailLoeschen.ElementClassName := 'btn btn-sm bg-info m-1';
    btnEmailLoeschen.ElementFont := efCSS;
    btnEmailLoeschen.ElementPosition := epIgnore;
    btnEmailLoeschen.HeightStyle := ssAuto;
    btnEmailLoeschen.HeightPercent := 100.000000000000000000;
    btnEmailLoeschen.WidthStyle := ssAuto;
    btnEmailLoeschen.WidthPercent := 100.000000000000000000;
    SetEvent(btnEmailLoeschen, Self, 'OnClick', 'btnEmailLoeschenClick');
    xdsEmails.SetParentComponent(Self);
    xdsEmails.Name := 'xdsEmails';
    xdsEmails.AfterApplyUpdates := xdsEmailsAfterApplyUpdates;
    xdsEmails.AfterOpen := xdsEmailsAfterOpen;
    xdsEmails.AfterPost := xdsEmailsAfterPost;
    xdsEmails.AfterDelete := xdsEmailsAfterDelete;
    xdsEmails.EntitySetName := 'EmailEingang';
    xdsEmails.Connection := DM2.XDataWebConnection1;
    xdsEmails.QueryTop := 1;
    xdsEmails.Left := 144;
    xdsEmails.Top := 72;
    xdsEmailsEmailEmpfangenUhrzeit.SetParentComponent(xdsEmails);
    xdsEmailsEmailEmpfangenUhrzeit.Name := 'xdsEmailsEmailEmpfangenUhrzeit';
    xdsEmailsEmailEmpfangenUhrzeit.FieldName := 'EmailEmpfangenUhrzeit';
    xdsEmailsID.SetParentComponent(xdsEmails);
    xdsEmailsID.Name := 'xdsEmailsID';
    xdsEmailsID.FieldName := 'ID';
    xdsEmailsID.Required := True;
    xdsEmailsarchiviert.SetParentComponent(xdsEmails);
    xdsEmailsarchiviert.Name := 'xdsEmailsarchiviert';
    xdsEmailsarchiviert.FieldName := 'archiviert';
    xdsEmailsarchiviert.Size := 250;
    xdsEmailsEmailFrom.SetParentComponent(xdsEmails);
    xdsEmailsEmailFrom.Name := 'xdsEmailsEmailFrom';
    xdsEmailsEmailFrom.FieldName := 'EmailFrom';
    xdsEmailsEmailFrom.Size := 250;
    xdsEmailsEmailFromName.SetParentComponent(xdsEmails);
    xdsEmailsEmailFromName.Name := 'xdsEmailsEmailFromName';
    xdsEmailsEmailFromName.FieldName := 'EmailFromName';
    xdsEmailsEmailFromName.Size := 250;
    xdsEmailsEmailTo.SetParentComponent(xdsEmails);
    xdsEmailsEmailTo.Name := 'xdsEmailsEmailTo';
    xdsEmailsEmailTo.FieldName := 'EmailTo';
    xdsEmailsEmailTo.Size := 250;
    xdsEmailsEmailCC.SetParentComponent(xdsEmails);
    xdsEmailsEmailCC.Name := 'xdsEmailsEmailCC';
    xdsEmailsEmailCC.FieldName := 'EmailCC';
    xdsEmailsEmailCC.Size := 250;
    xdsEmailsEmailBetreff.SetParentComponent(xdsEmails);
    xdsEmailsEmailBetreff.Name := 'xdsEmailsEmailBetreff';
    xdsEmailsEmailBetreff.FieldName := 'EmailBetreff';
    xdsEmailsEmailBetreff.Size := 250;
    xdsEmailsEmailPriority.SetParentComponent(xdsEmails);
    xdsEmailsEmailPriority.Name := 'xdsEmailsEmailPriority';
    xdsEmailsEmailPriority.FieldName := 'EmailPriority';
    xdsEmailsEmailOrganization.SetParentComponent(xdsEmails);
    xdsEmailsEmailOrganization.Name := 'xdsEmailsEmailOrganization';
    xdsEmailsEmailOrganization.FieldName := 'EmailOrganization';
    xdsEmailsEmailOrganization.Size := 100;
    xdsEmailsEmailbearbeitet.SetParentComponent(xdsEmails);
    xdsEmailsEmailbearbeitet.Name := 'xdsEmailsEmailbearbeitet';
    xdsEmailsEmailbearbeitet.FieldName := 'Emailbearbeitet';
    xdsEmailsEmailbearbeitetvon.SetParentComponent(xdsEmails);
    xdsEmailsEmailbearbeitetvon.Name := 'xdsEmailsEmailbearbeitetvon';
    xdsEmailsEmailbearbeitetvon.FieldName := 'Emailbearbeitetvon';
    xdsEmailsEmailbearbeitetvon.Size := 50;
    xdsEmailsKundennummer.SetParentComponent(xdsEmails);
    xdsEmailsKundennummer.Name := 'xdsEmailsKundennummer';
    xdsEmailsKundennummer.FieldName := 'Kundennummer';
    xdsEmailsKundennummer.Size := 13;
    xdsEmailsPosteingang.SetParentComponent(xdsEmails);
    xdsEmailsPosteingang.Name := 'xdsEmailsPosteingang';
    xdsEmailsPosteingang.FieldName := 'Posteingang';
    xdsEmailsEmailID.SetParentComponent(xdsEmails);
    xdsEmailsEmailID.Name := 'xdsEmailsEmailID';
    xdsEmailsEmailID.FieldName := 'EmailID';
    xdsEmailsEmailID.Size := 100;
    xdsEmailsEmailReceipt.SetParentComponent(xdsEmails);
    xdsEmailsEmailReceipt.Name := 'xdsEmailsEmailReceipt';
    xdsEmailsEmailReceipt.FieldName := 'EmailReceipt';
    xdsEmailsEmailReceipt.Size := 100;
    xdsEmailsEmailgelesen.SetParentComponent(xdsEmails);
    xdsEmailsEmailgelesen.Name := 'xdsEmailsEmailgelesen';
    xdsEmailsEmailgelesen.FieldName := 'Emailgelesen';
    xdsEmailsEmailContentType.SetParentComponent(xdsEmails);
    xdsEmailsEmailContentType.Name := 'xdsEmailsEmailContentType';
    xdsEmailsEmailContentType.FieldName := 'EmailContentType';
    xdsEmailsEmailContentType.Size := 100;
    xdsEmailsEmailgelesenvon.SetParentComponent(xdsEmails);
    xdsEmailsEmailgelesenvon.Name := 'xdsEmailsEmailgelesenvon';
    xdsEmailsEmailgelesenvon.FieldName := 'Emailgelesenvon';
    xdsEmailsEmailgelesenvon.Size := 50;
    xdsEmailsEmailReplyTo.SetParentComponent(xdsEmails);
    xdsEmailsEmailReplyTo.Name := 'xdsEmailsEmailReplyTo';
    xdsEmailsEmailReplyTo.FieldName := 'EmailReplyTo';
    xdsEmailsEmailReplyTo.Size := 100;
    xdsEmailsEmailReplyToName.SetParentComponent(xdsEmails);
    xdsEmailsEmailReplyToName.Name := 'xdsEmailsEmailReplyToName';
    xdsEmailsEmailReplyToName.FieldName := 'EmailReplyToName';
    xdsEmailsEmailReplyToName.Size := 100;
    xdsEmailsEmailUIDL.SetParentComponent(xdsEmails);
    xdsEmailsEmailUIDL.Name := 'xdsEmailsEmailUIDL';
    xdsEmailsEmailUIDL.FieldName := 'EmailUIDL';
    xdsEmailsEmailUIDL.Size := 250;
    xdsEmailsEmailBCC.SetParentComponent(xdsEmails);
    xdsEmailsEmailBCC.Name := 'xdsEmailsEmailBCC';
    xdsEmailsEmailBCC.FieldName := 'EmailBCC';
    xdsEmailsEmailBCC.Size := 50;
    xdsEmailsEmailBest.SetParentComponent(xdsEmails);
    xdsEmailsEmailBest.Name := 'xdsEmailsEmailBest';
    xdsEmailsEmailBest.FieldName := 'EmailBest';
    xdsEmailsSchreibzeichen.SetParentComponent(xdsEmails);
    xdsEmailsSchreibzeichen.Name := 'xdsEmailsSchreibzeichen';
    xdsEmailsSchreibzeichen.FieldName := 'Schreibzeichen';
    xdsEmailsSchreibzeichen.Size := 10;
    xdsEmailsGesendete.SetParentComponent(xdsEmails);
    xdsEmailsGesendete.Name := 'xdsEmailsGesendete';
    xdsEmailsGesendete.FieldName := 'Gesendete';
    xdsEmailsGesendetUhrzeit.SetParentComponent(xdsEmails);
    xdsEmailsGesendetUhrzeit.Name := 'xdsEmailsGesendetUhrzeit';
    xdsEmailsGesendetUhrzeit.FieldName := 'GesendetUhrzeit';
    xdsEmailsPersNo.SetParentComponent(xdsEmails);
    xdsEmailsPersNo.Name := 'xdsEmailsPersNo';
    xdsEmailsPersNo.FieldName := 'PersNo';
    xdsEmailsPersColor.SetParentComponent(xdsEmails);
    xdsEmailsPersColor.Name := 'xdsEmailsPersColor';
    xdsEmailsPersColor.FieldName := 'PersColor';
    xdsEmailsBearbeitungsnotiz.SetParentComponent(xdsEmails);
    xdsEmailsBearbeitungsnotiz.Name := 'xdsEmailsBearbeitungsnotiz';
    xdsEmailsBearbeitungsnotiz.FieldName := 'Bearbeitungsnotiz';
    xdsEmailsBearbeitungsnotiz.Size := 255;
    xdsEmailsNurText.SetParentComponent(xdsEmails);
    xdsEmailsNurText.Name := 'xdsEmailsNurText';
    xdsEmailsNurText.FieldName := 'NurText';
    xdsEmailsNurText.Size := 255;
    xdsEmailsObjektReferenz.SetParentComponent(xdsEmails);
    xdsEmailsObjektReferenz.Name := 'xdsEmailsObjektReferenz';
    xdsEmailsObjektReferenz.FieldName := 'ObjektReferenz';
    xdsEmailsObjektReferenz.Size := 13;
    xdsEmailsObjektnummer.SetParentComponent(xdsEmails);
    xdsEmailsObjektnummer.Name := 'xdsEmailsObjektnummer';
    xdsEmailsObjektnummer.FieldName := 'Objektnummer';
    xdsEmailsObjektnummer.Size := 25;
    xdsEmailsEmailKonto.SetParentComponent(xdsEmails);
    xdsEmailsEmailKonto.Name := 'xdsEmailsEmailKonto';
    xdsEmailsEmailKonto.FieldName := 'EmailKonto';
    xdsEmailsEmailKonto.Size := 50;
    xdsEmailsFreigabe.SetParentComponent(xdsEmails);
    xdsEmailsFreigabe.Name := 'xdsEmailsFreigabe';
    xdsEmailsFreigabe.FieldName := 'Freigabe';
    xdsEmailsFreigabe.Size := 50;
    xdsEmailsEmailBody.SetParentComponent(xdsEmails);
    xdsEmailsEmailBody.Name := 'xdsEmailsEmailBody';
    xdsEmailsEmailBody.FieldName := 'EmailBody';
    xdsEmailsEmailBody.Size := 255;
    xdsEmailsMSG.SetParentComponent(xdsEmails);
    xdsEmailsMSG.Name := 'xdsEmailsMSG';
    xdsEmailsMSG.FieldName := 'MSG';
    xdsEmailsMSG.Size := 255;
    sourceEmails.SetParentComponent(Self);
    sourceEmails.Name := 'sourceEmails';
    sourceEmails.DataSet := xdsEmails;
    sourceEmails.Left := 72;
    sourceEmails.Top := 72;
    xdsEGesendet.SetParentComponent(Self);
    xdsEGesendet.Name := 'xdsEGesendet';
    xdsEGesendet.AfterOpen := xdsEGesendetAfterOpen;
    xdsEGesendet.EntitySetName := 'Email';
    xdsEGesendet.Connection := DM2.XDataWebConnection1;
    xdsEGesendet.QueryString := '$select=ID, EmailEmpfangenUhrzeit, EmailFromName, EmailFrom, EmailBetreff, NurText&$filter=archiviert eq null&$orderby=ID DESC';
    xdsEGesendet.Left := 280;
    xdsEGesendet.Top := 72;
    xdsEGesendetEmailBetreff.SetParentComponent(xdsEGesendet);
    xdsEGesendetEmailBetreff.Name := 'xdsEGesendetEmailBetreff';
    xdsEGesendetEmailBetreff.FieldName := 'EmailBetreff';
    xdsEGesendetEmailBetreff.Size := 255;
    xdsEGesendetKundennummer.SetParentComponent(xdsEGesendet);
    xdsEGesendetKundennummer.Name := 'xdsEGesendetKundennummer';
    xdsEGesendetKundennummer.FieldName := 'Kundennummer';
    xdsEGesendetKundennummer.Size := 13;
    xdsEGesendetgesendetUhrzeit.SetParentComponent(xdsEGesendet);
    xdsEGesendetgesendetUhrzeit.Name := 'xdsEGesendetgesendetUhrzeit';
    xdsEGesendetgesendetUhrzeit.FieldName := 'gesendetUhrzeit';
    xdsEGesendetBearbeitungsnotiz.SetParentComponent(xdsEGesendet);
    xdsEGesendetBearbeitungsnotiz.Name := 'xdsEGesendetBearbeitungsnotiz';
    xdsEGesendetBearbeitungsnotiz.FieldName := 'Bearbeitungsnotiz';
    xdsEGesendetBearbeitungsnotiz.Size := 255;
    xdsEGesendetEmailFrom.SetParentComponent(xdsEGesendet);
    xdsEGesendetEmailFrom.Name := 'xdsEGesendetEmailFrom';
    xdsEGesendetEmailFrom.FieldName := 'EmailFrom';
    xdsEGesendetEmailFrom.Size := 50;
    xdsEGesendetEmailFromName.SetParentComponent(xdsEGesendet);
    xdsEGesendetEmailFromName.Name := 'xdsEGesendetEmailFromName';
    xdsEGesendetEmailFromName.FieldName := 'EmailFromName';
    xdsEGesendetEmailFromName.Size := 50;
    xdsEGesendetEmailTo.SetParentComponent(xdsEGesendet);
    xdsEGesendetEmailTo.Name := 'xdsEGesendetEmailTo';
    xdsEGesendetEmailTo.FieldName := 'EmailTo';
    xdsEGesendetEmailTo.Size := 255;
    xdsEGesendetEmailCC.SetParentComponent(xdsEGesendet);
    xdsEGesendetEmailCC.Name := 'xdsEGesendetEmailCC';
    xdsEGesendetEmailCC.FieldName := 'EmailCC';
    xdsEGesendetEmailCC.Size := 255;
    xdsEGesendetEmailBCC.SetParentComponent(xdsEGesendet);
    xdsEGesendetEmailBCC.Name := 'xdsEGesendetEmailBCC';
    xdsEGesendetEmailBCC.FieldName := 'EmailBCC';
    xdsEGesendetEmailBCC.Size := 255;
    xdsEGesendetEmailBody.SetParentComponent(xdsEGesendet);
    xdsEGesendetEmailBody.Name := 'xdsEGesendetEmailBody';
    xdsEGesendetEmailBody.FieldName := 'EmailBody';
    xdsEGesendetEmailBody.Size := 255;
    xdsEGesendetID.SetParentComponent(xdsEGesendet);
    xdsEGesendetID.Name := 'xdsEGesendetID';
    xdsEGesendetID.FieldName := 'ID';
    xdsEGesendetID.Required := True;
  finally
    lblEmailArt.AfterLoadDFMValues;
    TC.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    MSGLOESCHEN.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    btnKontaktZuordnen.AfterLoadDFMValues;
    btnTicketErstellen.AfterLoadDFMValues;
    btnEmailLoeschen.AfterLoadDFMValues;
    xdsEmails.AfterLoadDFMValues;
    xdsEmailsEmailEmpfangenUhrzeit.AfterLoadDFMValues;
    xdsEmailsID.AfterLoadDFMValues;
    xdsEmailsarchiviert.AfterLoadDFMValues;
    xdsEmailsEmailFrom.AfterLoadDFMValues;
    xdsEmailsEmailFromName.AfterLoadDFMValues;
    xdsEmailsEmailTo.AfterLoadDFMValues;
    xdsEmailsEmailCC.AfterLoadDFMValues;
    xdsEmailsEmailBetreff.AfterLoadDFMValues;
    xdsEmailsEmailPriority.AfterLoadDFMValues;
    xdsEmailsEmailOrganization.AfterLoadDFMValues;
    xdsEmailsEmailbearbeitet.AfterLoadDFMValues;
    xdsEmailsEmailbearbeitetvon.AfterLoadDFMValues;
    xdsEmailsKundennummer.AfterLoadDFMValues;
    xdsEmailsPosteingang.AfterLoadDFMValues;
    xdsEmailsEmailID.AfterLoadDFMValues;
    xdsEmailsEmailReceipt.AfterLoadDFMValues;
    xdsEmailsEmailgelesen.AfterLoadDFMValues;
    xdsEmailsEmailContentType.AfterLoadDFMValues;
    xdsEmailsEmailgelesenvon.AfterLoadDFMValues;
    xdsEmailsEmailReplyTo.AfterLoadDFMValues;
    xdsEmailsEmailReplyToName.AfterLoadDFMValues;
    xdsEmailsEmailUIDL.AfterLoadDFMValues;
    xdsEmailsEmailBCC.AfterLoadDFMValues;
    xdsEmailsEmailBest.AfterLoadDFMValues;
    xdsEmailsSchreibzeichen.AfterLoadDFMValues;
    xdsEmailsGesendete.AfterLoadDFMValues;
    xdsEmailsGesendetUhrzeit.AfterLoadDFMValues;
    xdsEmailsPersNo.AfterLoadDFMValues;
    xdsEmailsPersColor.AfterLoadDFMValues;
    xdsEmailsBearbeitungsnotiz.AfterLoadDFMValues;
    xdsEmailsNurText.AfterLoadDFMValues;
    xdsEmailsObjektReferenz.AfterLoadDFMValues;
    xdsEmailsObjektnummer.AfterLoadDFMValues;
    xdsEmailsEmailKonto.AfterLoadDFMValues;
    xdsEmailsFreigabe.AfterLoadDFMValues;
    xdsEmailsEmailBody.AfterLoadDFMValues;
    xdsEmailsMSG.AfterLoadDFMValues;
    sourceEmails.AfterLoadDFMValues;
    xdsEGesendet.AfterLoadDFMValues;
    xdsEGesendetEmailBetreff.AfterLoadDFMValues;
    xdsEGesendetKundennummer.AfterLoadDFMValues;
    xdsEGesendetgesendetUhrzeit.AfterLoadDFMValues;
    xdsEGesendetBearbeitungsnotiz.AfterLoadDFMValues;
    xdsEGesendetEmailFrom.AfterLoadDFMValues;
    xdsEGesendetEmailFromName.AfterLoadDFMValues;
    xdsEGesendetEmailTo.AfterLoadDFMValues;
    xdsEGesendetEmailCC.AfterLoadDFMValues;
    xdsEGesendetEmailBCC.AfterLoadDFMValues;
    xdsEGesendetEmailBody.AfterLoadDFMValues;
    xdsEGesendetID.AfterLoadDFMValues;
  end;
end;

end.
